import { render, staticRenderFns } from "./base.vue?vue&type=template&id=304677c5&scoped=true&"
var script = {}
import style0 from "./base.vue?vue&type=style&index=0&id=304677c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304677c5",
  null
  
)

export default component.exports